import { createSlice } from "@reduxjs/toolkit";
import { supportersAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const supportersSlice = createSlice({
  name: "supporters",
  initialState: data,
  reducers: {
    supportersSlice(state) {
      state.isLoading = false;
    },
    supportersSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    supportersSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    supportersSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const supportersHandler = () => async (dispatch: any) => {
  try {
    dispatch(supportersAction.supportersSlice());
    const response: any = await supportersAPI();
    dispatch(supportersAction.supportersSliceSuccess(response));
  } catch (e: any) {
    dispatch(supportersAction.supportersSliceFailure(e?.response?.data?.message));
    dispatch(supportersAction.supportersSliceReset());
  }
};
export default supportersSlice.reducer;
export const supportersAction = supportersSlice.actions;
